import React, { Suspense } from "react";
import Logo from "../../assets/images/logo-2x.png";
import image1 from "../../assets/images/loginFirstImage.webp";
import image2 from "../../assets/images/loginSecoundImage.webp";
import LoginPageEllipse_1 from "../../assets/images/LoginPageEllipse_1.webp";
import LoginPageEllipse_2 from "../../assets/images/LoginPageEllipse_2.webp";
import LoginPageEllipseBlue_1 from "../../assets/images/LoginPageEllipseBlue_1.webp";
import LoginPageEllipseBlue_2 from "../../assets/images/LoginPageEllipseBlue_2.webp";
import { Spin } from "antd";

// Lazy load heavy components
const LoginForm = React.lazy(() => import("./LoginForm"));
const ImageRotator = React.lazy(() => import("../../Animation/ImageRotator"));

// Preload images
const preloadImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

// Preload all images when component is imported
preloadImages([
  image1,
  image2,
  LoginPageEllipse_1,
  LoginPageEllipse_2,
  LoginPageEllipseBlue_1,
  LoginPageEllipseBlue_2,
  Logo,
]);

const Login = () => {
  const brandingImages = [image2, image1];
  const ellipseImagesBrown = [LoginPageEllipseBlue_1, LoginPageEllipse_1];
  const ellipseImagesBlue = [LoginPageEllipseBlue_2, LoginPageEllipse_2];

  return (
    <div>
      <main className="login-page">
        <Suspense fallback={<Spin size="large" />}>
          <ImageRotator
            className="login-bg-ellipse"
            images={ellipseImagesBrown}
            interval={6000}
            loading="lazy"
          />
          <ImageRotator
            className="login-bg-ellipse-left"
            images={ellipseImagesBlue}
            interval={6000}
            loading="lazy"
          />

          <div className="branding-side">
            <ImageRotator
              images={brandingImages}
              interval={6000}
              loading="lazy"
            />
          </div>
          <div className="form-side">
            <LoginForm logo={Logo} />
          </div>
        </Suspense>
      </main>
    </div>
  );
};

export default React.memo(Login);
